import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C01AccordionProps = RenderingProps<
  C01AccordionFields,
  C01AccordionRenderingParams,
  AccordionPlaceholder
>;

export type AccordionPlaceholder = {
  'accordion-item-container'?: {
    uid?: string;
  }[];
};

export type C01AccordionFields = {
  Headline?: Field<string>;
  HeadlineTag?: KeyValuePair;
  HeadlineIcon?: KeyValuePair;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
};

export type C01AccordionRenderingParams = {
  HeadlineAlignment?: string;
  HeadlineIconPlacement?: string;
  OpenFirstItem?: boolean;
  LimitToSingleItem?: boolean;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
